
import { MapPin, DollarSign, Users, Zap } from "lucide-react";

const FeaturesSection = () => {
  return (
    <section id="features" className="py-16 bg-secondary">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="font-montserrat text-4xl md:text-5xl font-extrabold text-primary mb-6">
            Benefits for Property Owners
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Quiet Corner transforms underutilized spaces into profitable amenities while enhancing your property's appeal to modern professionals.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="text-center">
            <div className="bg-orange/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <DollarSign className="h-8 w-8 text-orange" />
            </div>
            <h3 className="font-montserrat text-xl font-bold text-quietcove-blue mb-3">New Revenue Stream</h3>
            <p className="text-gray-600">Generate additional income from previously unused spaces with our smart booking system.</p>
          </div>
          
          <div className="text-center">
            <div className="bg-orange/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Zap className="h-8 w-8 text-orange" />
            </div>
            <h3 className="font-montserrat text-xl font-bold text-quietcove-blue mb-3">Zero CapEx</h3>
            <p className="text-gray-600">We handle all installation costs and equipment. Start earning immediately with no upfront investment.</p>
          </div>
          
          <div className="text-center">
            <div className="bg-orange/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="h-8 w-8 text-orange" />
            </div>
            <h3 className="font-montserrat text-xl font-bold text-quietcove-blue mb-3">Enhanced Property Value</h3>
            <p className="text-gray-600">Attract quality tenants and visitors with modern, tech-enabled workspace amenities.</p>
          </div>
          
          <div className="text-center">
            <div className="bg-orange/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <MapPin className="h-8 w-8 text-orange" />
            </div>
            <h3 className="font-montserrat text-xl font-bold text-quietcove-blue mb-3">Flexible Installation</h3>
            <p className="text-gray-600">Our pods fit in lobbies, corridors, corners, and any underutilized space in your building.</p>
          </div>
        </div>

        <div className="bg-white rounded-3xl p-8 lg:p-12">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="font-montserrat text-3xl md:text-4xl font-bold text-quietcove-blue mb-6">
                Perfect for all kinds of spaces
              </h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700"><strong>Hotels:</strong> Offer guests private workspaces in lobbies and directly outside your conference space</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700"><strong>Convention Centers:</strong> Boost productivity of your conferences with bookable private offices throughout</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700"><strong>Hospitals:</strong> Provide needed private workspace for visitors, vendors, and doctors</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700"><strong>Retail & Mixed-Use:</strong> Add value to shopping centers, coffee shops and mixed developments</p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-gray-700"><strong>Transit Hubs:</strong> Allow travelers to escape the noise and get some work done on their regular commutes</p>
                </div>
              </div>
            </div>
            <div className="relative">
              <img 
                src="/lovable-uploads/08decc64-b2ed-4556-ba34-d6cccadb17e2.png" 
                alt="Quiet Corner pods in modern office space"
                className="w-full h-auto rounded-2xl shadow-lg brightness-125"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
